import { Pipe, PipeTransform } from '@angular/core';
import * as fns from 'date-fns/fp';
import { function as F } from 'fp-ts';

@Pipe({ name: 'fromNow', pure: false })
export class FromNowPipe implements PipeTransform {
  public transform(value: number | Date, hideSuffix = false): string {
    return F.pipe(
      value,
      fns.formatDistanceWithOptions({ addSuffix: !hideSuffix })(new Date()),
    );
  }
}
